module.exports = __webpack_public_path__ + "img/double-spline.bbc0ebd7.png";